module.exports = __webpack_public_path__ + "img/fitness-tracker.2ab8e78e.svg";